import React from 'react'

import { Icon, IconProps } from '@chakra-ui/react'

export const MicrophoneIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_587_342)">
        <path
          d="M9.87486 0.8125C8.18909 0.8125 6.82129 2.1803 6.82129 3.86607V9.97322C6.82129 11.659 8.18909 13.0268 9.87486 13.0268C11.5606 13.0268 12.9284 11.659 12.9284 9.97322V3.86607C12.9284 2.1803 11.5606 0.8125 9.87486 0.8125Z"
          fill="black"
        />
        <path
          d="M4.78571 9.97294C4.78571 9.41232 4.32847 8.95508 3.76786 8.95508C3.20724 8.95508 2.75 9.41232 2.75 9.97294C2.75 13.5156 5.35032 16.5214 8.85714 17.0264V18.1158H6.82143C6.26081 18.1158 5.80357 18.573 5.80357 19.1336C5.80357 19.6943 6.26081 20.1515 6.82143 20.1515H12.9286C13.4892 20.1515 13.9464 19.6943 13.9464 19.1336C13.9464 18.573 13.4892 18.1158 12.9286 18.1158H10.8929V17.0264C14.3997 16.5214 17 13.5156 17 9.97294C17 9.41232 16.5428 8.95508 15.9821 8.95508C15.4215 8.95508 14.9643 9.41232 14.9643 9.97294C14.9643 12.784 12.686 15.0622 9.875 15.0622C7.06398 15.0622 4.78571 12.784 4.78571 9.97294Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_587_342">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </Icon>
  )
}
